import Vue from 'vue'
import VueRouter from 'vue-router'
import * as AppMiddleware from './app.middleware'
import {appRoutes} from './routes'
import store from '@/store'
Vue.use(VueRouter)

const routes = [
  ...appRoutes
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

router.beforeEach((to, from, next)=>{
  // const path =  store.getters['session/currentPath']
  // if(path != to.path && path != from.path){
  //   next(path)
  // }
  AppMiddleware.pageLoader({to, from, next}, true)
})
router.beforeEach(AppMiddleware.isAuthenticated)
router.afterEach((from, next)=>{
  // store.commit("session/setCurrentPath", window.location.pathname)
  AppMiddleware.pageLoader({from, next}, false)
  
})
export default router
